module.exports = __webpack_public_path__ + "img/Kolja_Wiekhorst_2025.50b7955c.jpg";